import script from "./UserBlackListModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserBlackListModal.vue?vue&type=script&lang=ts&setup=true"

import "./UserBlackListModal.vue?vue&type=style&index=0&id=54ea15f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ea15f6"]])

export default __exports__